export default __webpack_public_path__ + "static/media/insee.2ce7a1b8.jfif";